export default function (price, currency, hidePeriod) {
  let currencySymbol;
  let formattedAmount;
  if (!currency) {
    const { pricing } = window.$store.getters;
    const { defaultCurrency } = pricing;
    currency = defaultCurrency;
  }
  switch (currency) {
    case 'USD': {
      currencySymbol = '$';
      break;
    }
    case 'CAD': {
      currencySymbol = 'CAD$';
      break;
    }
    case 'GBP': {
      currencySymbol = '£';
      break;
    }
    case 'AUD': {
      currencySymbol = 'AU$';
      break;
    }
    default: {
      currencySymbol = '$';
    }
  }
  if (price < 0) {
    price *= -1;
    price = parseFloat(price).toFixed(2);
    formattedAmount = !hidePeriod ? `- ${currencySymbol}${price}/month` : `- ${currencySymbol}${price}`;
  } else {
    price = parseFloat(price).toFixed(2);
    formattedAmount = !hidePeriod ? `${currencySymbol}${price}/month` : `${currencySymbol}${price}`;
  }
  return formattedAmount;
}



// WEBPACK FOOTER //
// ./app/src/shared/amountFilter.js